import {
  BOOK_TOUR, BOOK_TOUR_FAIL,
  FETCH_TOUR, FETCH_TOUR_FAIL,
  SET_BOOKING_GROUP,
  UPDATE_TOUR_INFORMATION_LOADING,
  UPDATE_TOUR_INFORMATION_FAIL,
  REMOVE_TOUR_LOADING
} from './types';
import { SLACK_WEBHOOKS } from '../config';
import axios from 'axios';
import { SetBooking /*, SetAffilateAppID*/ } from './currentBooking';
import { history } from '../components/app';
import { SlackWebhook } from './utils';
// import Cookies from 'js-cookie';
import { FetchIntineraries } from './itineraries';

export function BookingError(){
  return (dispatch) => {
    dispatch(SetBooking(false));
    dispatch({type:BOOK_TOUR_FAIL, payload:true})
  }
}


/**
 * Book Tour (Holds booking for 1 hour) via Busabout API
 *
 * @param {string} currency - iso currency (GBP, AUD, USD, CAD).
 * @param {string} payload - booking payload
 * @param {string} emailConsent - if email consent
 */
export function BookTour(currency, payload, emailConsent){

  const bookingURL = `${process.env.REACT_APP_BOOKING_API}?currency=${currency}&api_token=${process.env.REACT_APP_API_TOKEN}&email_consent=${emailConsent}`;

  //Affliate id from cookie
  // const affliate = (Cookies.get('affiliate_id') !== undefined) ? Cookies.get('affiliate_id'): '';

  //Set Affliate id
  // SetAffilateAppID(affliate)

  const config = {
    headers:{
      'Content-Type': 'text/plain'
    },
    withCredentials: true
  };

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(bookingURL, payload, config )
      .then((response) => {
        //console.log(response)
        dispatch({type:BOOK_TOUR})
        if(response.data){
          // console.log('booking success - group booking id', JSON.stringify(response.data) );
          dispatch({type:SET_BOOKING_GROUP});
          dispatch(SetBooking(false));
          resolve(response.data);
        }
      })
      .catch((err) => {
        console.error(err);
        dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! BOOKING API (POST) - '  + bookingURL + " " + err}));
        dispatch({type:BOOK_TOUR_FAIL, payload:false})
      });
    });

  }
}


/**
 * Fetch booking via Busabout API
 *
 * @param {string} bookingId - booking id number
 * @param {string} requestType - requestType
 */
export function FetchBooking(bookingId, requestType){

  const HAS_REQUEST_TYPE = (requestType === 'builder_fetch') ? `&request_type=builder_fetch&booking_id=${bookingId} `: '';
  const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingId}?api_token=${process.env.REACT_APP_API_TOKEN}${HAS_REQUEST_TYPE}`;


  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.get(bookingURL, {withCredentials: true})
      .then((response) => {
        dispatch({type:FETCH_TOUR, payload:response.data});
        if(requestType === 'builder_fetch') dispatch(FetchIntineraries(response.data.cyoa_token));
        resolve(response.data);
      })
      .catch((err)=>{
        console.error(err);
        dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (GET) - ' + bookingURL + " " + err}));
        history.push('/500');
        dispatch({type:FETCH_TOUR_FAIL})
      })
    })
  }
}


/**
 * Add trip information via Busabout API
 *
 * @param {string} bookingArr - booking payload
 */
export function AddTrip(bookingArr, payload){

  const config = {
     headers:{
       'Content-Type': 'application/json'
     },
     withCredentials: true
  }

  const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingArr.group_booking_id}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingArr.group_booking_id}`;

  return (dispatch) => {
  dispatch({type:UPDATE_TOUR_INFORMATION_LOADING, payload:true});
  return new Promise((resolve, reject) => {
    axios.post(bookingURL, payload, config)
    .then(response => {
      if(response.data){
        dispatch({type:UPDATE_TOUR_INFORMATION_LOADING, payload:false});
        dispatch({type:FETCH_TOUR, payload:response.data});
        resolve();
      }
    })
    .catch((err)=>{
      console.error(err);
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (POST) - ' + bookingURL + " " + err}));
      dispatch({type:UPDATE_TOUR_INFORMATION_FAIL, payload:false});
    })
  })
}



}


/**
 * DELETE trip information via Busabout API
 *
 * @param {string} bookingArr - booking payload
 */
 export function DeleteTrip(bookingArr, payload){

   const config = {
      headers:{
        'Content-Type': 'text/plain'
      },
      withCredentials: true,
      data:payload
   }

    const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingArr.group_booking_id}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingArr.group_booking_id}`;

    return (dispatch) => {

      dispatch({type:REMOVE_TOUR_LOADING, payload:true});

      return new Promise((resolve, reject) => {
        axios.delete(bookingURL, config)
        .then(response => {
          if(response.data){
            
            dispatch(FetchBooking(bookingArr.group_booking_id)).then(()=>{
              dispatch({type:REMOVE_TOUR_LOADING, payload:false});
              resolve();
            })
            
          }
        })
        .catch((err)=>{
          console.error(err);
          dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (DELETE) - ' + bookingURL + " " + err}));
          dispatch({type:REMOVE_TOUR_LOADING, payload:false});
        })
      });
    }

 }
 


 /** 
  * Fetch booking meta via Busabout API
  *  
  * @param {string} bookingId - booking id number
  * */ 
  export function FetchBookingMeta(bookingId){

    const bookingURL = `${process.env.REACT_APP_BOOKING_META}/${bookingId}?api_token=${process.env.REACT_APP_API_TOKEN}`; 

    return (dispatch) => {
      return new Promise((resolve, reject) => {
        axios.get(bookingURL, {withCredentials: true})
        .then((response) => {
          resolve(response.data);
        })
        .catch((err)=>{
          console.error(err);
          dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking META API (GET) - ' + bookingURL + " " + err}));
        })
      })
    }
  }


// WEBPACK FOOTER //
// ./src/actions/booking.js